export class SubmitCloseRequestExtensiongModel {

    CaseActionSK: string;
    date: string;
    seq: number;
    status: number;
    personSk: string;
    loginId: string;
    note: string;

    actionType?: number;


    constructor(data: any) {
        this.CaseActionSK = data?.CaseActionSK;
        this.date = data?.date;
        this.seq = 1;
        this.status = 6;
        this.personSk = data?.personSk;
        this.loginId = data?.loginId;
        this.note = data?.note;
    }

}